enum FormFields {
  Name = 'name',
  Type = 'type',
  Bedrooms = 'averageBedroomsNumber',
  Bathrooms = 'averageBathroomsNumber',
  TotalSqft = 'averageTotalSqft',
  InteriorSqft = 'averageInteriorSqft',
  ExteriorSqft = 'averageExteriorSqft',
  Prices = 'prices',
  FloorPlanFile = 'floorPlanFile',
  FloorPlanFileId = 'floorPlanFileId',
  FloorPlanLoading = 'floorPlanLoading',
  CustomRooms = 'customRooms',
  InventoryType = 'inventoryType',
}

const FormFieldsList = [
  FormFields.InventoryType,
  FormFields.Name,
  FormFields.Bedrooms,
  FormFields.Bathrooms,
  FormFields.TotalSqft,
  FormFields.InteriorSqft,
  FormFields.ExteriorSqft,
  FormFields.Prices,
  FormFields.FloorPlanFile,
  FormFields.FloorPlanFileId,
  FormFields.FloorPlanLoading,
  FormFields.CustomRooms,
];

export { FormFields, FormFieldsList };
